export default "__VITE_ASSET__D0ok6G06__"